/* eslint-disable */
import React, { useState } from 'react';
import { WeekPicker } from '@rentacenter/legacyracstrap';
import { add, startOfWeek, sub } from 'date-fns';

import styles from './Goals.module.scss';

import { StoreGoals } from './StoreGoals/StoreGoals';
import { SalesGoals } from './SalesGoals/SalesGoals';
import { CollectionGoals } from './CollectionGoals/CollectionGoals';
import { useTranslation } from 'react-i18next';

export const goalsTestId = 'goalsTestId';

export const Goals = () => {
  const{t,i18n} = useTranslation('calendar')
  const today = new Date();
  const [week, setWeek] = useState<Date>(startOfWeek(today));

  return (
    <div data-testid={goalsTestId} className={styles.goals}>
      <WeekPicker
        className={`${styles.weekPicker} ${styles.custweekpicker}`}
        name="weekPicker"
        datePickerProps={{
          maxDate: add(today, { years: 1 }),
          minDate: sub(today, { years: 1 })
        }}
        value={week}
        onChange={setWeek}
      />

      <div className={styles.section}>
        <h3>{t('Store Goals')}</h3>
        <StoreGoals startDate={week} />
      </div>

      <div className={styles.section}>
        <h3>{t('Sales Goals')}</h3>
        <SalesGoals startDate={week} />
      </div>

      <div className={styles.section}>
        <h3>{t('Collection Goals')}</h3>
        <CollectionGoals startDate={week} />
      </div>
    </div>
  );
};
